import React from 'react';
import {
    FormControl,
    IconButton,
    MenuItem,
    Select,
    Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const ROWS_PER_PAGE_OPTIONS = [25, 50, 100];

const TechnicalMapTabletPagination = ({
                                          count,
                                          page,
                                          onPageChange,
                                          rowsPerPage,
                                          onRowsPerPageChange,
                                          isGrouped,
                                          totalJobsCount,
                                      }) => {
    const totalPages = count === 0 ? 0 : Math.ceil(count / rowsPerPage);
    const from = count === 0 ? 0 : page * rowsPerPage + 1;
    const to = count === 0 ? 0 : Math.min(count, (page + 1) * rowsPerPage);
    const rangeLabel = isGrouped
        ? `Группы ${from}–${to} из ${count}`
        : `${from}–${to} из ${count}`;

    const handlePrev = () => {
        if (page > 0) {
            onPageChange(page - 1);
        }
    };

    const handleNext = () => {
        if (page < totalPages - 1) {
            onPageChange(page + 1);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                py: 2,
                px: 1,
            }}
        >
            {isGrouped && count > 0 && (
                <Typography sx={{fontSize: '14px', color: 'text.secondary'}}>
                    {`Всего строк: ${totalJobsCount}`}
                </Typography>
            )}

            <Typography sx={{fontSize: '16px', fontWeight: 600}}>
                {count === 0 ? 'Нет данных' : rangeLabel}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 0.5,
                }}
            >
                <IconButton
                    size="small"
                    aria-label="Предыдущая страница"
                    onClick={handlePrev}
                    disabled={page <= 0 || count === 0}
                >
                    <ChevronLeftIcon/>
                </IconButton>

                <Typography sx={{fontSize: '14px', minWidth: '120px', textAlign: 'center'}}>
                    {count === 0
                        ? 'Страница 0 из 0'
                        : `Страница ${page + 1} из ${totalPages}`}
                </Typography>

                <IconButton
                    size="small"
                    aria-label="Следующая страница"
                    onClick={handleNext}
                    disabled={page >= totalPages - 1 || count === 0}
                >
                    <ChevronRightIcon/>
                </IconButton>
            </Box>

            <FormControl size="small" sx={{minWidth: 200}} disabled={count === 0}>
                <Select
                    value={rowsPerPage}
                    onChange={onRowsPerPageChange}
                    displayEmpty
                    sx={{
                        fontSize: '14px',
                        '& .MuiSelect-select': {
                            paddingRight: '40px',
                        },
                    }}
                >
                    {ROWS_PER_PAGE_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                            {isGrouped
                                ? `${option} групп на странице`
                                : `${option} на странице`}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default TechnicalMapTabletPagination;
